export default __webpack_public_path__ + "static/media/quote-left.478c6513.svg";